import {isMobile} from "react-device-detect";

import React, {useEffect, useState, useMemo} from 'react';
import { NavLink as RouterLink } from "react-router-dom";
import {useLoaderData, useNavigation, useParams} from "react-router-dom";
import {Button} from "@mui/material";
import Icon from '@mui/material/Icon';

import {isManager} from "ultra/helpers/partner";
import {normalizeRoute, restorePath} from "ultra/helpers/route";
import {getClientUrl} from 'ultra/configs/general'
import { hasFullAccess } from "ultra/helpers/auth";

import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { setPageTitle } from '../../../../../Helpers/router';
import {useGlobalCustomContext} from '../../../../../Helpers/context';
import {getShopHistory} from '../../../Helpers/history';

import {useConfigStore} from '../../../../../Stores/config';

import PreloaderTable from '../../../../../Components/Preloaders/PreloaderTable';

import UserHistoryLink from '../../../../Content/Widgets/UserHistoryLink'
import InlineActions from '../../../../Content/Widgets/InlineActions';

import TableView from '../../../../Content/Widgets/Table';
import BreadcrumbsWidget from '../../../../Content/Widgets/Breadcrumbs';
import TitleWidget from '../../../../Content/Widgets/Title';
import FiltersLine from '../../../../Content/Widgets/FiltersLine';
import OrderInlineActions from '../../../../Content/Widgets/OrderInlineActions';
// import DateValue from '../../../../Content/Widgets/DateValue';
// import UserHistoryLinkByID from '../../../../Content/Widgets/UserHistoryLinkByID';

// import NodeHistoryInlineActions from '../../../Components/NodeHistoryInlineActions';

import {useBackdropPreloaderStore} from '../../../../../Stores/backdropPreloader';
// import {useToasterStore} from '../../../../../Stores/toster';

import AdaptiveDialog from '../../../../../Components/Adaptive/Dialog';

import {NODE_ACTIONS} from '../../../../Content/Reducers/node';

import ProductWidget from '../ProductWidget';

import './index.scss';

export default () => {
    const initHistory = useLoaderData();

    let {partner, shop} = useParams();

    const navigation = useNavigation();
    const {configs} = useConfigStore();

    // const {showError} = useToasterStore();
    const {nodeState, nodeDispatch} = useGlobalCustomContext();
    const {hideBackdropPreloader} = useBackdropPreloaderStore(); // showBackdropPreloader
    const {userState} = useGlobalCustomContext();

    const [showConfiguration, setShowConfiguration] = useState();
    const [widget, setWidget] = useState();
    const [widgetData, setWidgetData] = useState();
    const [history, setHistory] = useState();
    const [tableOptions, setTableOptions] = useState();
    const [config, setConfig] = useState();
    const [permits, setPermits] = useState();
    const [actions, setActions] = useState([]);

    const fields = useMemo(() => {
        if (history?.partner?.fields) {
            const fields = {...history?.partner?.fields}
            Object.keys(fields).map(i => {
                fields[i].extraData = history
            })
            return fields;
        }

        return {
            _timestamp: {
                type: 'timestamp',
                placeholder: 'Дата'
            },
            _oid: {
                type: 'order',
                placeholder: 'Номер заявки',
                extraData: initHistory
            },
            _init_by: {
                type: 'history-user-link',
                placeholder: 'Замовник',
            },
            data_text: {
                type: 'request',
                placeholder: 'Заявка'
            },
            total: {
                type: 'shop-total',
                placeholder: "До сплати"
            },
            _city: {
                type: 'city',
                placeholder: 'Місто'
            }
            // data: {
            //     type: 'notification',   // history-details
            //     placeholder: 'Дані'
            // }
        }
    },[history])

    useEffect(() => {
        setPermits({})

        setPageTitle('Історія замовлень')
    }, [])

    useEffect(() => {
        if (nodeState.updatePageContentStart) {
            nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_END});
            updatePage()
        }
    }, [nodeState])

    useEffect(() => {
        if (navigation.state === 'idle') {
            updateHistory(initHistory);
        }
    }, [navigation])

    useEffect(() => {
        const actions = []

        actions.push({
            id: 'product-config',
            icon: <InfoOutlinedIcon className='Icon' />,
            onClick: () => {
                setShowConfiguration(true);
            }
        })

        {history?.partner?.widgets && Object.keys(history?.partner?.widgets)
            .filter(w => isManager(userState?.user, history?.partner))
            .map(w =>
                actions.push({
                    id: 'product-widget-' + w,
                    label: history?.partner?.widgets?.[w]?.title,
                    icon: <Icon className='Icon'>{history?.partner?.widgets?.[w]?.icon}</Icon>,
                    onClick: () => {
                        onShowWidget(
                            {id: w, ...history?.partner?.widgets?.[w]},
                            history?.partner?.widgets_data?.[w]
                        )
                    }
                })
            )}
        
        setActions(actions)
    }, [userState?.user, history])

    useEffect(() => {
        const config = {templateOptions: {}}

        if (configs) {
            setConfig({...config})
        }
    }, [userState?.user, configs])

    function updateHistory(history) {
        setHistory({...history})

        if (history?.partner?.table) {
            if (history.partner.table.mobile && isMobile) {
                setTableOptions(history.partner.table.mobile)
            }
            else if (history.partner.table.desktop && !isMobile) {
                setTableOptions(history.partner.table.desktop)
            }
        }
        else {
            setTableOptions(isMobile ? {
                visible: ['_init_by'], // , 'code'
                hidden: ['_timestamp', '_city', 'data_text'],
                noHeaders: true
            } : {
                visible: ['_timestamp', '_city', '_init_by'], //  'code', '_oid',
                hidden: ['data_text'],
                // noHeaders: true,
                // unfolded: true,
            })
        }

        hideBackdropPreloader()
    }

    // const selectClasses = (data) => {
    //     return data?._code
    //         ? 'tr_' + data?._code.replace(':', '_')
    //         : '';
    // }

    const content = {
        title: `${history?.partner?.title}`
    }

    const breadcrumbs = {}
    breadcrumbs['\\profile\\partnership'] = {title: "Партнерська панель"}

    const updatePage = () => {
        const url = new URL(window.location.href);

        updateHistory({});
        getShopHistory(partner, shop, url.search)
            .promise
            .then(updateHistory)
    }

    const onShowWidget = (w,d) => {
        setWidget(w);
        setWidgetData(d);
    }

    const onWidgetClose = () => {
        setWidget(null);
        setWidgetData(null);
    }

    const onSubmitCallback = () => {
        setWidget(null);
        setWidgetData(null);
        nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_START});
    }

    return <div id="Content" className='Content'>
            <div className='HistoryShopAdminPage'>
                {history && <TitleWidget permits={permits} content={content} config={config} breadcrumbs={breadcrumbs} actions={<InlineActions actions={actions} />}/>}
                {history && <BreadcrumbsWidget hideRoot links={breadcrumbs} hide={content.hideBreadcrumbs} />}

                {isMobile && <div className='MobileFiltersLine'>
                    <FiltersLine
                        size="small"
                        filters={config?.showFilters?.filterByInline}
                    />
                </div>}

                {(!fields) && <PreloaderTable/>}

                {fields && history && <TableView
                    showPreloader={!history?.list}
                    content={history}
                    fields={fields}
                    showPagination={true}
                    tableOptions={tableOptions}
                    // actions={(id) => OrderInlineActions({
                        // content: history?.list?.[id],
                        // city: getClientCity(window) || DEFAULT_CITY
                    // }})}
                    // selectClasses={selectClasses}
                />}

                {/* {history?.page && <NodeInlineActions permits={history?.permits} node={history?.page} hideHistory={true} showCleanHistory unfolded={!isMobile} className="CurrentPageInlineActions" city={city} hasFullAccess={hasFullAccess(userState.user)} />} */}

                <AdaptiveDialog open={widget} onClose={onWidgetClose} title={widget?.title}>
                    <ProductWidget widget={widget} type="shop" widgetData={widgetData} partner={partner} product={shop} onSubmitCallback={onSubmitCallback}/>
                </AdaptiveDialog>

                <AdaptiveDialog open={showConfiguration} onClose={() => setShowConfiguration(false)} title="Конфігурація">
                    {history?.link && <Grid item xs={12} className='labelWrap'>
                        <span className='label'>Посилання:</span>
                        <span className='labelValue'>
                            <RouterLink to={getClientUrl(history?.partner.city, restorePath(normalizeRoute(history?.link._uri)))}>{history?.link.title}</RouterLink>
                        </span>
                    </Grid>}
                    {history?.access && <Grid item xs={12} className='labelWrap'>
                        <span className='label'>Доступ:</span>
                        <span className='labelValue'>
                            {history.access.map(i => 
                                <Chip label={i.displayName ? (hasFullAccess(userState.user) ? <UserHistoryLink id={i.id} name={i.displayName} /> : i.displayName) : i} variant="outlined" />
                            )}
                            {/* <RouterLink to={restorePath(normalizeRoute(history.form._uri))}>{history.form.title}</RouterLink> */}
                        </span>
                    </Grid>}
                    {history?.manager && <Grid item xs={12} className='labelWrap'>
                        <span className='label'>Менеджер:</span>
                        <span className='labelValue'>
                        <Chip label={<>
                                {history.manager.conversation && <span>
                                    {history.manager.conversation.dialog && history.manager.conversation.private && 'Приватний чат '}
                                    {!history.manager.conversation.dialog && history.manager.conversation.private && 'Публічний чат '}
                                    {!history.manager.conversation.private && !history.manager.conversation.dialog && 'Канал'}
                                </span>}

                                {history?.manager?.topic && <span>Нотифікації у {history.manager.topic}</span>}
                            </>} variant="outlined" />
                            {history.manager.contact && <Chip label={hasFullAccess(userState.user) ? <UserHistoryLink id={history.manager.contact.id} name={history.manager.contact.displayName} /> : history.manager.contact.displayName} variant="outlined" />}
                        </span>
                    </Grid>}
                    {history?.owners && <Grid item xs={12} className='labelWrap'>
                        <span className='label'>Власник:</span>
                        <span className='labelValue'>
                            {history.owners.map(i => <Chip label={i.displayName || i} variant="outlined" />)}
                            {/* <RouterLink to={restorePath(normalizeRoute(history.form._uri))}>{history.form.title}</RouterLink> */}
                        </span>
                    </Grid>}
                </AdaptiveDialog>
            </div>
        </div>
}
